import getMetaTag from '@/shared/utils/getMetaTag'

const cdnUrl = getMetaTag('cdnUrl')

export const namespaced = true

export const state = {
  cdnUrl,
}
